import _ from 'lodash';

export const mirrorKeys = (keys) => {
  if (!keys || !_.isArray(keys)) throw new Error('keys must be an array');
  return _.reduce(
    keys,
    (accObj, key) => {
      accObj[key] = key;
      return accObj;
    },
    {}
  );
};

export const toAbsoluteUrl = (pathname) => process.env.REACT_APP_PUBLIC_URL + pathname;


export const getFilters = (payload) => {
  const { operationStatus, operationDate, name, lastName, document, batch, type } = payload;
  const operations = operationStatus.split(',').map(o => Number(o));
  const filters = {
    operationStatus: operations,
    operationDate: operationDate ? `[${formatDateLinks(operationDate)}]` : '',
    name,
    lastName,
    document,
    batch,
    type
  };
  return filters;
};

export const getFiltersForLinks = (payload) => {
  const { operationStatus, operationDate, name, lastName, document, batch, type } = payload;

  const operations = operationStatus.split(',').map(o => Number(o));
  const filters = {
    operationStatus: operations.filter(op => op === 2 || op === 4 || op === 1 || op === 7),
    operationDate: operationDate ? `[${formatDateLinks(operationDate)}]` : '',
    name,
    lastName,
    document,
    batch,
    type
  };
  return filters;
};

export const formatDate = (date) => {
  const arrDate = date.split("/");
  let newDate1 = arrDate[0] + "-" + arrDate[1] + "-" + (Number(arrDate[2]) - 1).toString();
  let newDate2 = arrDate[0] + "-" + arrDate[1] + "-" + arrDate[2];
  return newDate1 + " 21:00:00;" + newDate2 + " 20:59:59";
};
export const formatDateLinks = (date) => {
  const arrDate = date.split("/");
  let newDate1 = arrDate[2] + "-" + arrDate[1] + "-" + (Number(arrDate[0]) - 1).toString();
  let newDate2 = arrDate[2] + "-" + arrDate[1] + "-" + arrDate[0];
  return newDate1 + " 21:00:00;" + newDate2 + " 20:59:59";
};

export const isEmptyOrNil = (item) => {
  if (_.isObject(item)) {
    return _.isEmpty(item);
  } else {
    return _.isNil(item);
  }
};
